import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="site-workshop-footer border-t"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-10 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/branding/bbw-logo.jpg" alt="Beyond Board Woodworking logo" className="h-28 w-auto object-contain" />
            </div>
            <p className="mt-6 text-[#B8B7B2] max-w-md leading-relaxed">
              Layered basswood signs, door hangers, wall decor, memorial pieces,
              and personalized gifts designed, cut, painted, and assembled by hand.
            </p>
            <div className="copper-line my-8 max-w-md" />
            <p className="text-xs uppercase tracking-[0.2em] text-[#26C6D5]">
              Made by hand · Made in our shop
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#D8A34B] font-semibold mb-4">
              Explore
            </p>
            <ul className="space-y-3 text-[#F5F0E6]">
              <li><Link to="/gallery" className="hover:text-[#26C6D5]">Our Work</Link></li>
              <li><a href="/offers/" className="hover:text-[#26C6D5]">Current Offers</a></li>
              <li><Link to="/what-we-make" className="hover:text-[#26C6D5]">What We Make</Link></li>
              <li><Link to="/quote" className="hover:text-[#26C6D5]">Custom Orders</Link></li>
              <li><Link to="/process" className="hover:text-[#26C6D5]">How It Works</Link></li>
              <li><Link to="/faq" className="hover:text-[#26C6D5]">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-[#26C6D5]">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-[#D8A34B] font-semibold mb-4">
              Contact Beyond Board
            </p>
            <ul className="space-y-3 text-[#F5F0E6]">
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#26C6D5]" />
                <a href="mailto:beyondboardwoodwork@gmail.com" className="hover:text-[#26C6D5]">
                  beyondboardwoodwork@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[#26C6D5]" /> By appointment only</li>
              <li className="flex items-center gap-3"><Instagram className="w-4 h-4 text-[#26C6D5]" /> @beyondboardwoodwork</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-[#F5F0E6]/5 flex flex-col md:flex-row md:justify-between gap-4 text-xs text-[#B8B7B2]">
          <span>© {new Date().getFullYear()} Beyond Board Woodwork. All rights reserved.</span>
          <Link to="/privacy" className="hover:text-[#26C6D5]">Privacy & Analytics</Link>
          <span>Crafted with sawdust & care.</span>
        </div>
        <div className="mt-3 text-center text-[11px] text-[#B8B7B2]/90">
          Website By Blair Creative Studios
        </div>
      </div>
    </footer>
  );
}
